'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineEpics = undefined;

var _merge = require('rxjs/observable/merge');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
  Merges all epics into a single one.
 */
var combineEpics = exports.combineEpics = function combineEpics() {
  for (var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++) {
    epics[_key] = arguments[_key];
  }

  return function (actions, store) {
    return _merge.merge.apply(undefined, _toConsumableArray(epics.map(function (epic) {
      return epic(actions, store);
    })));
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/lib/combineEpics.js
// module id = 1041
// module chunks = 0